import { Container } from '../../components';
import DesignIcon from '../../public/svg/design.svg';
import SpecificationIcon from '../../public/svg/specification.svg';
import SupportIcon from '../../public/svg/support.svg';
import WebIcon from '../../public/svg/web.svg';
import styles from './mvp-process.module.css';
import commonStyles from './mvp.module.css';

const cards = [
  {
    id: 1,
    icon: <SpecificationIcon className={styles.icon} />,
    title: 'Week 1',
    description: 'Analysis, UX',
  },
  {
    id: 2,
    icon: <DesignIcon className={styles.icon} />,
    title: 'Week 2',
    description: 'UI Design',
  },
  {
    id: 3,
    icon: <WebIcon className={styles.icon} />,
    title: 'Week 3 - 5',
    description: 'Development',
  },
  {
    id: 4,
    icon: <SupportIcon className={styles.icon} />,
    title: 'Week 6',
    description: 'QA, Launch',
  },
];

export default function MVPProcess() {
  return (
    <section className={styles.process}>
      <Container>
        <div className={styles.content}>
          <h2 className={commonStyles.h2} id="process">
            YOUR MVP IN 6 WEEKS - OUR PROVEN PROCESS
          </h2>
          <p className={commonStyles.text}>
            We help startups move fast — from idea to functional MVP in just six
            weeks. Our proven process covers everything from business analysis
            and UX to development, testing, and launch, using AI and Claude Code
            where they can accelerate development and bring your product to
            market faster. Each week is planned with precision, so you stay in
            the loop with weekly demos and full transparency.
          </p>
          <p className={commonStyles.text}>
            This isn&apos;t just a prototype — it&apos;s a real,
            production-ready version built with clean, native code that you
            fully own. It&apos;s a smart way to validate your idea, attract
            investors, or onboard your first users — combining proven
            development practices with modern AI-powered tools without wasting
            time or budget.
          </p>
        </div>
      </Container>
      <ul className={styles.list}>
        {cards.map((card) => (
          <li key={card.id} className={styles.item}>
            <div className={styles.card}>
              <h6 className={styles.card_title}>{card.title}</h6>
              {card.icon}
              <p className={styles.card_text}>{card.description}</p>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}
